import React from 'react'
import styled, { css } from 'styled-components'

// Components
import { FormField } from '../../Forms/FormField'
import { S_FormInput } from '../../Forms/FormInput/FormInput.styles'
import { ErrorIndicator } from '../../ErrorIndicator'
import { CellErrorIndicator } from './CellErrorIndicator'
import { S_AutoCompleteInput } from '../../AutoCompleteInput'
import { S_FormFieldWrapper } from '../../Forms/FormField'

// Constants
import { tableStylesConfig, tableCellStyles, cssBreakpoints } from '../../../_constants/styles'
import { colors } from '../../../_constants/colors'
import { S_Checkbox, S_CheckboxLabelText } from '../../Forms/FormField/CustomFields/Checkbox/Checkbox.styles'

// Colors
const { MATERIAL_RED, MATERIAL_RED_LIGHT_50 } = colors

// Styled Components
const S_BorderIndicator = styled.div`
  position: absolute;
  top: -1px;
  left: -1px;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  z-index: 1;
`

const S_EditableCell_Error = styled.div`
  position: absolute;
  z-index: 5; /* we want this above the input */
  top: 0;
  right: 0;
  &:hover {
    z-index: 6; /* place above inactive errors */
  }
`

export const S_EditableCell = styled.div`
  ${tableCellStyles}
  display: flex;
  align-items: center;
  padding: 0; /* input will have the padding */
  position: relative;

  ${(props) =>
    props.mobileMaxWidth &&
    css`
      @media screen and (max-width: ${cssBreakpoints.mobileMd}) {
        max-width: ${(props) => (props.mobileMaxWidth ? `${props.mobileMaxWidth}px` : 'none')};
        width: 100%;
      }
    `}

  ${S_FormFieldWrapper} {
    max-width: 100%;
    width: 100%;
  }

  /* Update FormInput styles to match table */
  ${S_FormInput} {
    padding: ${tableStylesConfig.cellPaddingV} ${tableStylesConfig.cellPaddingH};
    border: none;
    font-size: ${tableStylesConfig.fontSize};
    line-height: normal;
    flex-grow: 1;
    position: relative;
    z-index: 4;
    background: transparent; /* TODO: see if we should force this everywhere */
  }

  ${S_BorderIndicator} {
    border: ${tableStylesConfig.borderWidth} solid ${(props) => (props.invalid ? MATERIAL_RED_LIGHT_50 : `transparent`)};
  }

  &:hover {
    ${S_BorderIndicator} {
      border-color: ${(props) => (props.invalid ? MATERIAL_RED : `#ccc`)};
      z-index: 2;
    }
  }

  /* Focus-within */
  &:focus-within {
    ${S_BorderIndicator} {
      border-color: ${(props) => (props.invalid ? MATERIAL_RED : `#999`)};
      z-index: 3;
    }
  }
  ${S_AutoCompleteInput} {
    width: 100%;
    max-width: 100%;
    .chip-position {
      margin-right: 3px;
    }
    .formFieldInput {
      border-style: none;
    }
  }
  ${S_Checkbox} {
    margin: 0 auto;
    input {
      position: absolute;
    }
    ${S_CheckboxLabelText} {
      display: none;
    }
  }
`

/**
 * Basically takes the same input as a FormRow component
 * @param {*} param0
 */
export const EditableCell = (props) => {
  const {
    id,
    type,
    value,
    label = null,
    disabled,
    onChange,
    onBlur,
    error,
    style = {},
    Cell = FormField,
    mobileMaxWidth = null,
    ...rest
  } = props
  const invalid = !!error
  return (
    //use style when trying to set column widths
    <S_EditableCell invalid={invalid} mobileMaxWidth={mobileMaxWidth} style={style}>
      {/* Focus indicator */}
      {/* <S_BorderIndicator /> */}

      {/* Error Indicator / tooltip */}
      {error && (
        <S_EditableCell_Error>
          <ErrorIndicator error={error} errorTitle={`${label} Error`}>
            {(props) => <CellErrorIndicator {...props} />}
          </ErrorIndicator>
        </S_EditableCell_Error>
      )}

      {/* Form Field */}
      <Cell {...props} />
    </S_EditableCell>
  )
}
